<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center;margin-top:0.5em"><span>Also by Penelope Lively</span></p>
<p class="linespace">
</p><p style="text-align:center;margin-top:0.5em"><span><i>Fiction</i></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">GOING BACK</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">THE ROAD TO LICHFIELD</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">NOTHING MISSING BUT THE SAMOVAR AND OTHER STORIES</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">TREASURES OF TIME</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">NEXT TO NATURE, ART</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">PERFECT HAPPINESS</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">CORRUPTION AND OTHER STORIES</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">ACCORDING TO MARK</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">PACK OF CARDS</span>:</span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">COLLECTED SHORT STORIES 1978–1986</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">MOON TIGER</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">PASSING ON</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">CITY OF THE MIND</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">CLEOPATRA'S SISTER</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">HEAT WAVE</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">BEYOND THE BLUE MOUNTAINS</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">SPIDERWEB</span></span></p>
<p class="linespace">
</p><p style="text-align:center;margin-top:0.5em"><span><i>Nonfiction</i></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">THE PRESENCE OF THE PAST</span>:</span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">AN INTRODUCTION TO LANDSCAPE HISTORY</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">OLEANDER, JACARANDA</span>:</span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">A CHILDHOOD PERCEIVED</span></span></p>
<p style="text-align:center;margin-top:0.5em"><span><span class="fsc">A HOUSE UNLOCKED</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Also_by.vue?12ccc929